/**
 * Encodes a string to base64
 *
 * If urlSafe is true, the base64 string will be urlSafe
 */
export const encodeBase64 = (text: string, urlSafe = false) => {
  const bytes = new TextEncoder().encode(text)
  const binString = String.fromCodePoint(...bytes)

  const base64String = btoa(binString)

  if (urlSafe) {
    return base64String.replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '')
  }

  return base64String
}

/**
 * Decodes a string from base64
 *
 * If urlSafe is true, the base64 string will be urlSafe
 */
export const decodeBase64 = (base64String: string, urlSafe = false) => {
  if (urlSafe) {
    base64String = base64String
      .replaceAll('-', '+')
      .replaceAll('_', '/')
      .padEnd(base64String.length + ((4 - (base64String.length % 4)) % 4), '=')
  }

  const binString = atob(base64String)
  const bytes = new Uint8Array(binString.length)

  for (let i = 0; i < binString.length; i++) {
    bytes[i] = binString.charCodeAt(i)
  }

  return new TextDecoder().decode(bytes)
}
